<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query.storageRoomType" :options="storageRoomTypes" placeholder="business.label.storageRoomType" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.storageRoomNo" width="100"/>
        <vxe-column field="name" title="business.label.storageRoomName" width="120"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageRoomTypes}" field="storageRoomType" title="business.label.storageRoomType" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageEnvironments}" field="storageEnvironment" title="business.label.storageEnvironment" width="80"/>
        <vxe-column field="floor" title="business.label.floor" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="automatic" title="business.label.automatic" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="allocable" title="business.label.allocable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="aggregate" title="business.label.aggregate" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="weighable" title="business.label.weighable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="checkable" title="business.label.checkable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="separable" title="business.label.separable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="serialNumberManagement" title="business.label.serialNumberManagement" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="caseOnly" title="business.label.caseOnly" width="70"/>
        <vxe-column field="tag" title="business.label.tag" width="80"/>
        <vxe-column field="reservedLocations" title="business.label.reservedLocations" width="80"/>
        <vxe-column field="numberOfPickingOrder" title="business.label.numberOfPickingOrder" width="80"/>
        <vxe-column field="numberOfBarcode" title="business.label.numberOfBarcode" width="80"/>
        <vxe-column field="exchangeStorageRoom.name" title="business.label.exchangeStorageRoom"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { StorageRoom } from '@/api/dto/common/StorageRoom'

export default {
  name: 'StorageRoomTable',
  data() {
    return {
      loading: false,
      query: new StorageRoom(),
      data: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  props: {
    storageRoomTypes: {
      type: Array,
      default: []
    },
    storageEnvironments: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.query.toJSONObject()
      }
      findAll('storageRoomFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new StorageRoom()
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row) {
      this.$emit('edit', row)
    }
  }
}
</script>